/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  ButtonPayoutListPlugin,
  IButtonPayoutListPluginMethods,
  ErrorPayoutListPlugin,
  IErrorPayoutListPluginMethods,
  EventDetailPlugin,
  IEventDetailMethods,
  EventTimelinePlugin,
  IEventTimelineMethods,
  HeaderPayoutListListPlugin,
  IHeaderPayoutListListPluginMethods,
  LoadingPayoutListListPlugin,
  ILoadingPayoutListListPluginMethods,
  PoliciesListPlugin,
  IPoliciesListMethods,
  ResentCredentialPlugin,
  IResentCredentialMethods,
  SettingsPayoutListListPlugin,
  ISettingsPayoutListListPluginMethods,
  StaticPagePayoutListPlugin,
  IStaticPagePayoutListPluginMethods,
  UpdateStatusPlugin,
  IUpdateStatusMethods,
} from './plugins';

export type TAgent = IButtonPayoutListPluginMethods &
  IErrorPayoutListPluginMethods &
  IEventDetailMethods &
  IEventTimelineMethods &
  IHeaderPayoutListListPluginMethods &
  ILoadingPayoutListListPluginMethods &
  IPoliciesListMethods &
  IResentCredentialMethods &
  ISettingsPayoutListListPluginMethods &
  IStaticPagePayoutListPluginMethods &
  IUpdateStatusMethods;

const getPlugins = () => {
  return [
    new StaticPagePayoutListPlugin(),
    new ErrorPayoutListPlugin(),
    new LoadingPayoutListListPlugin(),
    //Business logic plugins !
    new ButtonPayoutListPlugin(),
    new EventDetailPlugin(),
    new EventTimelinePlugin(),
    new HeaderPayoutListListPlugin(),
    new PoliciesListPlugin(),
    new ResentCredentialPlugin(),
    new SettingsPayoutListListPlugin(),
    new UpdateStatusPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
